import React, {useState} from "react";
import {Field} from 'formik';
import {FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput} from '@material-ui/core';
import styles from './FormikPasswordInput.module.scss';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';


export interface IFormikPasswordInputProps {
  name: string;
  label: string | any;
  cancelError?: boolean;
  cancelTouch?: boolean;
  loading?: boolean;
}

const CustomizedTextField = ({loading, form, field, cancelError, cancelTouch, ...props}: any) => {
  const touched = cancelTouch ? false : form.touched[field.name];
  const error = cancelError ? null : (touched && form.errors[field.name]);
  const valid = touched && !error;
  const [showPassword, setShowPassword] = useState(false);
  return (
    <FormControl
      onClick={() => form.setFieldTouched(field.name)}
      error={error ? true : false}
      className={valid ? (`${styles.valid} ` + styles.input) : styles.input}
      variant="outlined">
      <InputLabel className={styles.label} htmlFor={field.name}>{props.label}</InputLabel>
      <OutlinedInput
        type={showPassword ? 'text' : 'password'}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => {
                setShowPassword(!showPassword);
              }}
              edge="end"
            >
              {showPassword ? <Visibility/> : <VisibilityOff/>}
            </IconButton>
          </InputAdornment>
        }
        onChange={field.onChange}
        {...props}
        value={field.value}
        name={field.name}
        id={field.name}
      />
      <div className="PasswordErrorContainer">
        {(error) ?
          <FormHelperText
            className="DateSelectorError"
            error>{error}</FormHelperText> : null}
      </div>
    </FormControl>
  );
}


const FormikPasswordInput = ({loading, ...props}: IFormikPasswordInputProps) => loading ?
  (<SkeletonPlaceHolder
    className={styles.loadingField}
  >
    {props.label}
  </SkeletonPlaceHolder>) :
  (
    <Field
      component={CustomizedTextField}
      required
      fullWidth
      variant="outlined"
      id={props.name}
      {...props}
      autoComplete={props.name}
    />
  );

FormikPasswordInput.defaultProps = {
  name: "",
  label: "",
  cancelError: false,
  cancelTouch: false,
  loading: false,
};

export default FormikPasswordInput;
